import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const paymentRoutes: RouteRecordRaw[] = [
  {
    path: '/payments',
    name: ROUTES.PAYMENTS,
    component: () => import('@/modules/payments/views/PaymentsIndex.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.PAYMENTS_VIEW }
  }
]
